module.exports = __webpack_public_path__ + "img/like.9ea87efc.svg";